import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { queryClient } from '@/lib/queryClient';
import { ToastContextProvider } from '@/components/ui/use-toast';
import { Toaster } from '@/components/ui/toaster';
import { RouteTracker } from '@/components/RouteTracker';
import { CookieConsent } from '@/components/CookieConsent';
import './styles/globals.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastContextProvider>
        <BrowserRouter>
          <RouteTracker />
          <App />
          <CookieConsent />
        </BrowserRouter>
        <Toaster />
      </ToastContextProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
